// debounce avoids making too many requests to the server, waiting for a while in order to finally send the request
function debounce(callback, delay) {
	let timeout;

	const debounced = (...args) => {
		const context = this;
		clearTimeout(timeout);

		timeout = setTimeout(() => callback.apply(context, args), delay);
	};

	// Drops a queued call. Needed wherever something else is about to run the
	// same work immediately and a late timer would duplicate it — see
	// autosubmit_controller's flush().
	debounced.cancel = () => clearTimeout(timeout);

	return debounced;
}

export { debounce };
